import { Component, Input, OnInit, OnDestroy, AfterViewInit, ViewChild, ChangeDetectorRef, ElementRef, Renderer2 } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ViewTableComponent } from '../../base/view-table/view-table.component';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import moment from 'moment';
import flatpickr from 'flatpickr';
import { LocalizationService } from 'src/app/services/localization.service';
import { PaymentsEntityComponent } from '../../forms/payments-entity/payments-entity.component';
import { StudentDashboardWrapperComponent } from '../../student/student-dashboard-wrapper/student-dashboard-wrapper.component';
import { PageEvent } from '@angular/material/paginator';
import { HttpParameter } from 'src/app/types/http-parameter';
import { ComponentRefreshService } from 'src/app/services/component-refresh.service';
import { Subscription } from 'rxjs';
import { DialogService } from 'src/app/services/dialog.service';
import { EntityRESTService } from 'src/app/services/entity-rest.service';
import { UtilityService } from 'src/app/services/utility.service';
import { FieldsService } from 'src/app/services/fields.service';
import { DrupalRESTService } from 'src/app/services/drupal-rest.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthRESTService } from 'src/app/services/auth-rest.service';
import { AuthService } from 'src/app/services/auth.service';
import { MenuRESTService } from 'src/app/services/menu-rest.service';
import { FormBuilder } from '@angular/forms';
import { RouteEventsService } from 'src/app/route-events.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ConfigPagesService } from 'src/app/services/config-pages.service';
import { PackagesService } from 'src/app/services/packages.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from 'src/app/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { RefreshService } from 'src/app/services/refresh.service';
import { MatDialog } from '@angular/material/dialog';
import { PaymentReceiptComponent } from '../../payments/payment-receipt/payment-receipt.component';
import { StudioConfigService } from 'src/app/services/studio-config.service';
import { TranslateService } from '@ngx-translate/core';
import { PrintService } from 'src/app/services/print.service';
import { LoggerService } from '../../../services/logger.service';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'MMM DD, YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
}

@Component({
  selector: 'app-payments-report-view',
  templateUrl: './payments-report-view.component.html',
  styleUrls: ['./payments-report-view.component.css'],
  providers: [
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: MY_DATE_FORMATS }
  ]
})

/**
 * URL: /payment-reports
 */
export class PaymentsReportViewComponent extends ViewTableComponent implements OnInit, OnDestroy, AfterViewInit {

  StudentDashboardWrapperComponent = StudentDashboardWrapperComponent;
  override PaymentsEntityComponent = PaymentsEntityComponent;

  @ViewChild('dateRangeInput') dateRangeInput!: ElementRef;
  dateTimeRange: Date[] = [];
  dateRangeDisplayValue: string = '';
  private dateRangePicker?: any;

  // Subscription to the refresh service
  private refreshSubscription: Subscription;

  override displayedColumns: string[] = [
    'field_student_name',
    'field_payment_id',
    'field_date_and_time',
    'field_gross_tuition',
    'field_tax_collected',
    'field_enrollment_name',
    'field_payment_type',
    // 'field_status',
    'field_teacher',
    'field_notes',
    'edit',
  ];

  constructor(
    refreshService: RefreshService,
    dialogService: DialogService,
    entityRESTService: EntityRESTService,
    utilityService: UtilityService,
    fieldsService: FieldsService,
    drupalRESTService: DrupalRESTService,
    taxonomyService: TaxonomyService,
    router: Router,
    activatedRoute: ActivatedRoute,
    authRESTService: AuthRESTService,
    authService: AuthService,
    menuRESTService: MenuRESTService,
    formBuilder: FormBuilder,
    routeEventsService: RouteEventsService,
    permissionsService: PermissionsService,
    renderer2: Renderer2,
    configPages: ConfigPagesService,
    packagesService: PackagesService,
    snackBar: MatSnackBar,
    userRESTService: UserService,
    el: ElementRef,
    changeDetectorRef: ChangeDetectorRef,
    sanitizer: DomSanitizer,
    private studioConfigService: StudioConfigService,
    private componentRefreshService: ComponentRefreshService,
    private dialog: MatDialog,
    private translateService: TranslateService
  ) {
    super(
      refreshService,
      dialogService,
      entityRESTService,
      utilityService,
      fieldsService,
      drupalRESTService,
      taxonomyService,
      router,
      activatedRoute,
      authRESTService,
      authService,
      menuRESTService,
      formBuilder,
      routeEventsService,
      permissionsService,
      renderer2,
      configPages,
      packagesService,
      snackBar,
      userRESTService,
      el,
      changeDetectorRef,
      sanitizer,
      studioConfigService,
      componentRefreshService,
      translateService
    );
  }

  private _printService: PrintService;

  override ngOnInit() {
    // Initialize pagination values
    this.paginationIndex = 0;
    this.pageSize = 25;  // Set default page size

    // Call parent ngOnInit if it exists
    super.ngOnInit();

    // Subscribe to the refresh service
    this.refreshSubscription = this.componentRefreshService.paymentsReportRefresh$.subscribe(() => {
      LoggerService.log('PaymentsReportViewComponent: Received refresh event');
      this.refreshData();
    });

    // Standalone PrintService (parent's 25-arg constructor doesn't expose
    // it; mirror the students-list / enrollments-list pattern).
    this._printService = new PrintService(this._drupalRESTService, this._authService);
  }

  printPaymentReport() {
    const rows: any[] = (this.dataSource?.data ?? []) as any[];

    const escape = (v: any) => {
      const s = v === null || v === undefined ? '' : String(v);
      return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    };
    const formatDate = (v: any) => {
      if (!v) return '';
      const m = moment(v);
      return m.isValid() ? m.format('M/D/YYYY h:mm A') : '';
    };
    const money = (v: any) => {
      if (v === null || v === undefined || v === '') return '';
      const n = parseFloat(String(v).replace(/[^0-9.-]/g, ''));
      if (isNaN(n)) return String(v);
      return n.toFixed(2);
    };

    const headers = [
      'Student', 'Payment ID', 'Date', 'Amount Paid',
      'Tax', 'Enrollment', 'Payment Type', 'Teacher', 'Notes',
    ];
    const headerHtml = headers.map(h => `<th>${escape(h)}</th>`).join('');

    const bodyHtml = rows.map((r: any) => `<tr>
      <td>${escape(r.field_student_name)}</td>
      <td class="nowrap">${escape(r.field_payment_id)}</td>
      <td class="nowrap">${escape(formatDate(r.field_date_and_time))}</td>
      <td class="num">${escape(money(r.field_gross_tuition))}</td>
      <td class="num">${escape(money(r.field_tax_collected) || '0')}</td>
      <td>${escape(r.field_enrollment_name)}</td>
      <td>${escape(r.field_payment_type)}</td>
      <td>${escape(r.AllScheduledPaymentInstructors)}</td>
      <td>${escape(r.field_notes)}</td>
    </tr>`).join('');

    const filterSummary = this.buildPrintFilterSummary();
    const summaryHtml = filterSummary
      ? `<div class="filter-summary"><strong>Filters:</strong> ${escape(filterSummary)}</div>`
      : '';
    const countHtml = `<div class="row-count">${rows.length} payment${rows.length === 1 ? '' : 's'}</div>`;

    const content = `
      <h1 class="report-title">Payment List</h1>
      ${summaryHtml}
      ${countHtml}
      <table class="report-table">
        <thead><tr>${headerHtml}</tr></thead>
        <tbody>${bodyHtml}</tbody>
      </table>
    `;

    const styles = `
      @page { size: letter landscape; margin: 0.5in; }
      .report-table { width: 100%; border-collapse: collapse; font-size: 10px; }
      .report-table th, .report-table td { border: 1px solid #ccc; padding: 3px 5px; }
      .report-table th { background: #f0f0f0; }
      .report-table td.num { text-align: right; }
      .report-table td.nowrap { white-space: nowrap; }
      .filter-summary { margin: 4px 0; font-size: 11px; }
      .row-count { margin: 4px 0 8px 0; font-size: 11px; color: #555; }
    `;

    this._printService.print(content, {
      title: 'Payment List',
      styles,
      showSchoolName: true,
      promptPrint: true,
    });
  }

  private buildPrintFilterSummary(): string {
    const params = this.queryParams || [];
    const parts: string[] = [];
    for (const p of params) {
      if (!p || !p.parameter || !p.value) continue;
      if (p.parameter === 'field_payment_id_value') {
        parts.push(`Payment ID: ${p.value}`);
      } else if (p.parameter === 'field_check_number_value') {
        parts.push(`Check #: ${p.value}`);
      } else if (p.parameter === 'field_date_and_time' || p.parameter === 'field_date_and_time_value') {
        parts.push(`Date: ${String(p.value).replace('--', ' to ')}`);
      } else if (p.parameter === 'title_1') {
        parts.push(`Student: ${p.value}`);
      } else if (p.parameter === 'field_enrollment_package_name_target_id') {
        parts.push(`Package: ${p.value}`);
      }
    }
    return parts.join(' • ');
  }

  // Studio config is app-lifetime; released on destroy so the report can be collected.
  private datePickerConfigSubscription: Subscription;

  override ngOnDestroy() {
    // Unsubscribe to prevent memory leaks
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
    this.datePickerConfigSubscription?.unsubscribe();
    this.dateRangePicker?.destroy();

    // Call parent ngOnDestroy if it exists
    super.ngOnDestroy();
  }

  override onSubmit(form: NgForm): void {
    if (this.ShowProgressBar) { return; }

    // Convert moment dates to strings
    for (const property in form.form.value) {
      if (moment.isMoment(form.form.value[property])) {
        const momentValue = form.form.value[property] as moment.Moment;
        form.form.value[property] = this.reportDateService.formatCalendarParam(momentValue.toDate());
      }
    }

    // Build query params, skipping the raw dateRange field
    this.queryParams = [];
    this.routeParams = {};
    for (const property in form.form.value) {
      if (property === 'dateRange') { continue; }
      if (form.form.value[property] && form.form.value[property] !== '') {
        this.queryParams.push({ parameter: property, value: form.form.value[property] });
        this.routeParams[property] = form.form.value[property];
      }
    }

    // Inject the properly formatted min/max date params from the range picker
    if (this.dateTimeRange && this.dateTimeRange.length === 2 && this.dateTimeRange[0] && this.dateTimeRange[1]) {
      const minVal = this.reportDateService.formatCalendarParam(this.dateTimeRange[0]);
      const maxVal = this.reportDateService.formatCalendarParam(this.dateTimeRange[1]);
      this.queryParams.push({ parameter: 'field_date_and_time_value[min]', value: minVal });
      this.queryParams.push({ parameter: 'field_date_and_time_value[max]', value: maxVal });
      this.routeParams['field_date_and_time_value[min]'] = minVal;
      this.routeParams['field_date_and_time_value[max]'] = maxVal;
    }

    this.updateRouterParams(this.routeParams);
  }

  override getData(params: { parameter: string; value: string; }[]) {
    // Show Progress Bar (Loading indicator)
    this.ShowProgressBar = true;
    this.queryParams = params;

    // Add sorting paramaters, if available.
    if (this.sortParams !== undefined) {
      this.queryParams.push(this.sortParams)
    }

    // Load the new data with the filtering parameters.
    this._utilityService.getPaymentReport(
      this.queryParams
    )
      .subscribe((data) => {
        // ShowProgressBar
        this.ShowProgressBar = false;

        this.data = data;
        this.dataSource = new MatTableDataSource(data['results']);

        // Check if any of the data has a non-zero or non-empty field_tax_amount
        const hasTaxData = data && data['results'] && data['results'].some(
          (item: any) =>
            item.field_tax_collected !== '' &&
            item.field_tax_collected !== '0' &&
            item.field_tax_collected !== '0.00'
        );

        if (hasTaxData) {
          // If tax data exists, include the "Tax" column
          if (!this.displayedColumns.includes('field_tax_collected')) {
            this.displayedColumns.push('field_tax_collected');
          }
        } else {
          // If no tax data exists, remove the "Tax" column
          const taxColumnIndex = this.displayedColumns.indexOf('field_tax_amount');
          if (taxColumnIndex !== -1) {
            this.displayedColumns.splice(taxColumnIndex, 1);
          }
        }

        // Pagination
        if (data['results']) {
          this.setupPagination(data, params);
        }
      },
        error => this.handleError(error)
      )
  }

  private localizationService = new LocalizationService();

  ngAfterViewInit(): void {
    this.initDateRangePicker();
  }

  private initDateRangePicker(): void {
    if (!this.dateRangeInput?.nativeElement) return;

    this.datePickerConfigSubscription?.unsubscribe();
    this.datePickerConfigSubscription = this._studioConfigService.getStudioConfig().subscribe(config => {
      const countryCode = config?.['field_studio_address']?.[0]?.country_code || 'US';
      const formats = this.localizationService.getDateFormatsForCountry(countryCode);

      this.dateRangePicker = flatpickr(this.dateRangeInput.nativeElement, {
        mode: 'range',
        dateFormat: formats.flatpickrDateFormat,
        disableMobile: true,
        defaultDate: this.dateTimeRange?.length === 2 ? this.dateTimeRange : undefined,
        onChange: (selectedDates) => {
          if (selectedDates.length === 2) {
            this.dateTimeRange = selectedDates;
            this.dateRangeDisplayValue = this.dateRangePicker?.input?.value || '';

            const formattedMinDate = this.reportDateService.formatCalendarParam(this.dateTimeRange[0]);
            const formattedMaxDate = this.reportDateService.formatCalendarParam(this.dateTimeRange[1]);

            this.queryParams = this.queryParams.filter(param =>
              param.parameter !== 'field_date_and_time_value[min]' &&
              param.parameter !== 'field_date_and_time_value[max]' &&
              param.parameter !== 'dateRange'
            );

            this.queryParams.push({ parameter: 'field_date_and_time_value[min]', value: formattedMinDate });
            this.queryParams.push({ parameter: 'field_date_and_time_value[max]', value: formattedMaxDate });

            this.getData(this.queryParams);
          }
        }
      });
    });
  }

  openDateRangePicker(): void {
    this.dateRangePicker?.open();
  }

  refreshData(): void {
    LoggerService.log('PaymentsReportViewComponent: Refreshing data');
    this.getData(this.queryParams);
  }

  downloadPaymentReport(): void {
    const filterParams = (this.queryParams ?? [])
      .filter(param => param.parameter !== 'page' && param.parameter !== 'items_per_page')
      .map(param => ({ ...param }));

    const paramsObject = filterParams.reduce((acc, current) => {
      acc[current.parameter] = current.value;
      return acc;
    }, {});

    const processedParams = this.processParams(paramsObject);

    processedParams.forEach(processedParam => {
      if (!filterParams.some(param => param.parameter === processedParam.parameter)) {
        filterParams.push(processedParam);
      }
    });

    const csvFormatParam = filterParams.find(param => param.parameter === '_format');
    if (csvFormatParam) {
      csvFormatParam.value = 'csv';
    } else {
      filterParams.push({ parameter: '_format', value: 'csv' });
    }

    this.downloadCSVDrupalViews('/api/v1/payment_report/export', 'payment_report', filterParams);
  }

  override resetForm() {
    // Clear all stored params
    this.queryParams = [];
    this.sortParams = undefined;

    // Reset pagination
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.paginationIndex = 0;  // Reset the pagination index
      this.pageSize = 25;  // Reset page size
    }

    // Clear the form
    this.form.resetForm();

    // Clear any autocomplete options
    this.autoCompleteStudentAccountOptions = [];
    this.autoCompletePaymentIDOptions = [];

    // Reset date range picker
    this.dateTimeRange = [];
    this.dateRangeDisplayValue = '';
    this.dateRangePicker?.clear();

    // Make a fresh request with explicitly empty params
    this.getData([
      { parameter: 'page', value: '0' },
      { parameter: 'items_per_page', value: '10' }
    ]);

    // Update router last
    this.updateRouterParams({});
  }

  override pageChanged(event: PageEvent) {
    // Update pagination state
    this.paginationIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    // Always include pagination parameters
    const paginationParams: HttpParameter[] = [
      { parameter: 'page', value: this.paginationIndex.toString() },
      { parameter: 'items_per_page', value: this.pageSize.toString() }
    ];

    // Filter out any existing pagination params from queryParams
    const filteredQueryParams = this.queryParams.filter(param =>
      param.parameter !== 'page' && param.parameter !== 'items_per_page'
    );

    // Combine filtered query params with new pagination params
    const combinedParams = [...filteredQueryParams, ...paginationParams];
    this.getData(combinedParams);
  }

  override onPageSizeOptions() {
    return [10, 25, 50, 100, 250];
  }

  /**
   * Opens the payment receipt dialog for a specific payment
   * @param paymentId The ID of the payment to display
   */
  openReceiptDialog(paymentId: number): void {
    this.dialog.open(PaymentReceiptComponent, {
      width: '800px',
      height: '800px',
      data: { paymentId: paymentId },
      panelClass: 'receipt-dialog',
      disableClose: false
    });
  }
}
